<script setup lang="ts">
import type { Map } from "maplibre-gl";
import { watch } from "vue";
import { useElectoralDistricts } from "./useElectoralDistricts";

const { mapInstance, visible } = defineProps<{
  mapInstance: Map;
  visible: boolean;
}>();

const { toggle: toggleElectoralDistricts } = useElectoralDistricts(
  () => mapInstance,
);

// we have to watch the visible prop here instead of using a simple v-if on this component,
// because we would lose the order of execution when using v-if, which is important
// for the electoral districts layer to be added before the area editor layer
watch(
  () => visible,
  (visible) => {
    toggleElectoralDistricts(visible);
  },
);
</script>

<!-- renderless component: logic runs via composables in <script setup> -->
<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
